import { getApps, initializeApp, getApp } from 'firebase/app';
import { initializeAnalytics, isSupported, Analytics } from 'firebase/analytics';
import { IS_FLIPGIVE } from 'common/env';

let key = process.env.REACT_APP_FIREBASE_API_KEY;
let id = process.env.REACT_APP_FIREBASE_APP_ID;
const domain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const dbUrl = process.env.REACT_APP_FIREBASE_DATABASE_URL;
const project = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const bucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const msgId = process.env.REACT_APP_FIREBASE_SENDER_ID;

if (IS_FLIPGIVE) {
    key = process.env.REACT_APP_FLIPGIVE_FIREBASE_API_KEY;
    id = process.env.REACT_APP_FLIPGIVE_FIREBASE_APP_ID;
}

const firebaseConfig = {
    apiKey: key,
    authDomain: domain,
    databaseURL: dbUrl,
    projectId: project,
    storageBucket: bucket,
    messagingSenderId: msgId,
    appId: id,
};

export let firebaseAnalytics: Analytics;

export const initFirebase = () => {
    const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
    isSupported().then((supported) => {
        if (supported) {
            firebaseAnalytics = initializeAnalytics(app);
        }
    });
};
